import React from 'react';
import { injectV2 } from '../../../../injectV2';
import { UiLoggerStore } from '../../../../stores/UiLoggerStore';
import { WithTranslations, withTranslations } from '../../../../../utils/withTranslations';
import { TranslationKey } from '../../../../../i18n/i18n';
import { WidgetFeatureListItem } from './WidgetFeatureListItem/WidgetFeatureListItem';

import s from './WidgetFeatureList.scss';

export interface WidgetFeature {
  id: string;
  title: TranslationKey;
  description: TranslationKey;
  imagePath: string;
}

interface WidgetFeatureListProps extends WithTranslations {
  title: TranslationKey;
  features: WidgetFeature[];
  onItemClick: (value: WidgetFeature | null) => void;
  dataHook?: string;
  uiLoggerStore: UiLoggerStore;
}

const WidgetFeatureListCmp = (props: WidgetFeatureListProps) => {
  const { features, title, onItemClick, uiLoggerStore, dataHook, t } = props;
  const logWidgetActions = (event: React.MouseEvent) => {
    event.stopPropagation();
    uiLoggerStore.logWidgetActions('Main Title');
  };

  const createOnItemClick = (feature: WidgetFeature, selectedToolIndex: number) => (event: React.MouseEvent) => {
    event.stopPropagation();
    onItemClick(feature);
    uiLoggerStore.logWidgetActions('Select Tool', undefined, selectedToolIndex);
  };

  return (
    <div className={s.widgetFeatureList} data-hook={dataHook}>
      <div className={s.title} onClick={logWidgetActions}>
        {t(title)}
      </div>
      {features.map((feature, index) => (
        <WidgetFeatureListItem
          key={feature.title}
          number={index + 1}
          title={feature.title}
          onClick={createOnItemClick(feature, index)}
        />
      ))}
    </div>
  );
};

export const WidgetFeatureList = withTranslations(injectV2('uiLoggerStore')(WidgetFeatureListCmp));
